import { mapActions } from 'vuex'
import { addBookmark, deleteBookmark } from '@/service/member'
export default {
    data() {
        return {
            bookDic: {}
        }
    },
    methods: {
        ...mapActions(['getBookmarks']),
        async bindBookMarks(force) {
            const bookMarks = await this.getBookmarks(force)
            this.bookDic = {}
            bookMarks.forEach(item => {
                const { id } = item.detail || {}
                if (id) {
                    this.$set(this.bookDic, id, item)
                }
            })
        },
        async star(item) {
            let loadingToast
            try {
                let msg
                const { id } = this.bookDic[item.id] || {}
                loadingToast = this.$message.loading({
                    duration: 0,
                    forbidClick: true
                })
                if (id) {
                    await deleteBookmark(id)
                    msg = '取消收藏成功'
                } else {
                    const { href } = window.location
                    await addBookmark({
                        name: item.name,
                        url: href,
                        detail: { ...item, v: '1' }
                    })
                    this.$root.$emit('actionview', {
                        info: {
                            remark: `收藏-${item.name || item.productName}`,
                            to: href
                        },
                        actionType: 'clickview'
                    })
                    msg = '收藏成功'
                }
                await this.bindBookMarks(true)
                loadingToast.clear()
                this.$message.success(msg)
            } catch (error) {
                this.$message.fail(error.message)
                loadingToast && loadingToast.clear()
            }
        }
    }
}
